import api from './api';

/**
 * Income API Service
 * Provides methods for income estimation, confirmation, and recalculation
 */

export const getIncomeEstimate = () => {
  return api.get('/income/estimate');
};

export const confirmIncome = (sources) => {
  return api.post('/income/confirm', { sources });
};

export const recalculateIncome = () => {
  return api.post('/income/recalculate');
};

